import Entity from "./Entity"
import Level from "./Level"
import { TILE_SIZE, SCALE_FACTOR } from "./config"
import { getAnimation } from "./spritesheet"

export default class StartBlock extends Entity {
  static START_BLOCK_SIZE = TILE_SIZE * SCALE_FACTOR

  _destroyable: boolean
  get destroyable() {
    return this._destroyable
  }
  set destroyable(value) {
    if (this._destroyable === value) return
    this._destroyable = value
    if (value) {
      this.startBlink(0xff0000)
    } else {
      this.stopBlink()
    }
  }

  onExplode?: () => void

  constructor(params: {
    x: number,
    y: number,
    level: Level,
    destroyable: boolean,
  }) {
    super({
      x: params.x,
      y: params.y,
      level: params.level,
      speed: 0,
      width: StartBlock.START_BLOCK_SIZE,
      height: StartBlock.START_BLOCK_SIZE,
      textures: getAnimation("startBlock"),
      staticTileCoords: true,
    })
    this._destroyable = params.destroyable
    this._reset()
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isBlocking(_entityConstructor: typeof Entity.constructor): boolean {
    return true
  }

  private _reset() {
    this.tint = 0xff0000
    this._alive = true
    this.loop = false
    this.currentFrame = 0
    this.stopBlink()
  }

  explode() {
    if (!this.alive) return
    this.stopBlink()
    if (this._destroyable) {
      super.explode()
      this.tint = 0xffffff
      this.play()

      this.onComplete = () => {
        if (this.destroyable) {
          this.removeFromLevel()
          if (this.onExplode) {
            this.onExplode()
          }
        } else {
          this._reset()
        }
      }
    }
  }

  toString() {
    return "StartBlock"
  }
}
